export default __webpack_public_path__ + "static/media/tiktok-white.ff06dd48.svg";